import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'

class DetailBloc {

    cancelChannel = new Subject();
    submitCancelChannel = new Subject();
    repository = new DetailRepository()

    constructor() {
        this.cancelChannel.next({status: apiResponse.INITIAL})
        this.submitCancelChannel.next({status: apiResponse.INITIAL})
    }

    fetchCancel = async (query) => {
        try {
            this.cancelChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCancel(query).then((result) => {
                this.cancelChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.cancelChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchSubmitCancel = async (query) => {
        try {
            this.submitCancelChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSubmitCancel(query).then((result) => {
                this.submitCancelChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.submitCancelChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }


}

export default DetailBloc